module.exports = __webpack_public_path__ + "fonts/400-normal-latin.764c83e.woff2";